import { createClient } from "@sanity/client";

export default createClient({
  projectId: 'q7433i71',
  dataset: 'production',
  apiVersion: "2023-02-19",
})